var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 100,
    viewBox: "0 0 295 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.1932V38.0052C21.9671 30.4586 28.8405 26.6847 39.3533 26.6847C54.4471 26.6847 66.0375 37.8714 66.0375 55.5246V98.3825H47.8437V59.9723C47.8437 47.8437 41.7791 42.5878 32.7494 42.5878C25.0672 42.5878 18.1932 47.8437 18.1932 59.9723V98.3825H0V0Z",
    fill: "#3E3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.478 71.1577V28.3017H93.673V66.7119C93.673 78.8411 98.6607 84.0969 107.689 84.0969C115.372 84.0969 122.245 78.8411 122.245 66.7119V28.3017H140.438V98.3825H122.784V87.869C119.415 95.9573 113.081 100 102.165 100C87.0702 100 75.478 88.8134 75.478 71.1577Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.229 28.3016H169.152V38.5445C172.793 30.7268 179.8 26.6847 190.582 26.6847C200.421 26.6847 208.775 31.4006 213.358 39.8921C218.074 31.4006 224.814 26.6847 237.077 26.6847C252.171 26.6847 263.763 37.8713 263.763 55.5246V98.3824H245.568V59.9723C245.568 47.8436 239.773 42.5878 231.553 42.5878C223.062 42.5878 217.267 46.4967 217.267 59.9723V98.3824H199.072V59.9723C199.072 47.8436 193.008 42.5878 183.978 42.5878C176.296 42.5878 169.423 47.8436 169.423 59.9723V98.3824H151.229V28.3016Z",
    fill: "#3E3E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.729 36.5639C294.432 24.7978 288.493 13.699 278.839 6.87338C276.289 5.07133 273.536 3.59526 270.648 2.48585C266.354 0.835888 261.835 0 257.214 0H255.159V14.5278H257.213C263.241 14.5284 268.941 16.8545 273.267 21.0746C277.581 25.2841 280.049 30.9037 280.212 36.9524C280.216 37.1457 280.216 37.3373 280.216 37.5301V41.5816H294.742V37.5301C294.742 37.2064 294.738 36.8822 294.729 36.5639Z",
    fill: "url(#paint0_linear_1267_62677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1267_62677",
    x1: 261.141,
    y1: -1.87102,
    x2: 287.668,
    y2: 46.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C76F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumLogo);
export default __webpack_public_path__ + "static/media/hum-logo.b457630903e6cea6270ed1688ab6049c.svg";
export { ForwardRef as ReactComponent };